import options from './account-details.component';

export default {
    selector: 'dtServiceAccountDetailsPage',
    options
};
